import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";

const TITLE = 'Gold Karat Conversion Calculator | Convert 24K to 22K and More';
const DESCRIPTION = 'Use our Gold Karat Conversion Calculator to accurately convert gold weight between different karats like 24K to 22K, 18K, and more. Perfect for all your gold conversion needs.';
const KEYWORDS = 'Gold Karat Conversion Calculator, Convert 24K to 22K, Gold Conversion Formula, Karat Calculator, Gold Purity Calculator, Gold Weight Conversion';
const OG_URL = 'https://do-calculate.com/calculator/en/gold-karat/';

function GoldKaratCalculator() {
    const [goldWeight, setGoldWeight] = useState(1.00);
    const [goldKarat, setGoldKarat] = useState(24);
    const [conversionResults, setConversionResults] = useState(null);
    const [error, setError] = useState(null);

    const handleGoldWeightChange = (event) => {
        setGoldWeight(event.target.value);
    };

    const handleGoldKaratChange = (event) => {
        setGoldKarat(event.target.value);
    };

    const calculateGoldKarat = () => {
        const weight = parseFloat(goldWeight);
        const karat = parseFloat(goldKarat);

        if (isNaN(weight) || weight <= 0) {
            setError("Please enter a valid weight greater than zero");
            setConversionResults(null);
            return;
        }
        if (isNaN(karat) || karat <= 0 || karat > 24) {
            setError("Please enter a valid karat between 1 and 24");
            setConversionResults(null);
            return;
        }

        try {
            const pureGoldWeight = weight * (karat / 24);
            const results = {};
            const targetKarats = [24, 22, 21, 18, 14, 10];

            targetKarats.forEach(targetKarat => {
                const convertedWeight = pureGoldWeight / (targetKarat / 24);
                results[`karat_${targetKarat}`] = convertedWeight.toFixed(4);
            });

            setConversionResults(results);
            setError(null);
        } catch (err) {
            console.error(err);
            setError("An unexpected error occurred. Please try again.");
            setConversionResults(null);
        }
    };

    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '50px' }}>
                        <b>Gold Karat Conversion Calculator</b>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>
                                    Welcome to our <strong>Gold Karat Conversion Calculator</strong>, the best tool for <strong>converting gold weight between different karats</strong>. Whether you're looking to <strong>convert 24K gold to 22K</strong> or need to find the weight of gold in other karats, this calculator simplifies the process for you.
                                </p>
                                <br />
                                <p>
                                    Our <strong>gold conversion calculator</strong> uses the <strong>gold conversion formula</strong> to accurately compute the weight of gold in various karats based on the original weight and karat purity. This tool is perfect for anyone needing to <strong>convert 24 carat to 22 carat gold</strong> or any other karat conversion.
                                </p>
                                <p>
                                    Gold Conversion Formula:
                                    <br />
                                    To find the weight of gold in a different karat, use this formula:
                                    <br />
                                    <strong>Weight in New Karat = (Pure Gold Weight) ÷ (New Karat / 24)</strong>
                                    <br />
                                    Where:
                                    <ul>
                                        <li><strong>Pure Gold Weight</strong> is calculated as: Original Weight × (Original Karat / 24)</li>
                                        <li><strong>New Karat</strong> is the purity of the gold you want to convert to.</li>
                                    </ul>
                                </p>
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col calculatorStyle" style={{ minWidth: '300px' }}>
                                <div className="p-3 mb-2 bg-success text-white">
                                    Gold Karat Conversion Calculator
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <label htmlFor="goldWeight" className="form-label ms-2">
                                        Original Gold Weight:
                                    </label>
                                    <input
                                        type="number"
                                        id="goldWeight"
                                        value={goldWeight}
                                        onChange={handleGoldWeightChange}
                                        className="form-control"
                                        style={{ width: '100%', marginLeft: '10px' }}
                                        placeholder="e.g. 27.7"
                                        step="0.01"
                                        min="0"
                                    />
                                    <label htmlFor="goldKarat" className="form-label ms-2">
                                        Original Gold Karat:
                                    </label>
                                    <select
                                        id="goldKarat"
                                        style={{ width: '90%' }}
                                        className="form-select"
                                        value={goldKarat}
                                        onChange={handleGoldKaratChange}
                                    >
                                        <option value="24">24</option>
                                        <option value="22">22</option>
                                        <option value="21">21</option>
                                        <option value="18">18</option>
                                        <option value="14">14</option>
                                        <option value="10">10</option>
                                    </select>
                                </div>
                                <br />
                                <hr />
                                <button
                                    className="btn btn-success"
                                    style={{ fontSize: '20px' }}
                                    onClick={calculateGoldKarat}
                                >
                                    Calculate
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-auto">
                                <br />
                                {error && (
                                    <div className="alert alert-danger">
                                        <b><u>Error:</u></b> {error}
                                    </div>
                                )}
                                {conversionResults && (
                                    <div className="mt-4 p-3 alert alert-success">
                                        <h3>Results:</h3>
                                        <p>
                                            If you have <b>{goldWeight}</b> grams of <b>{goldKarat}</b> karat gold, it equals:
                                        </p>
                                        <ul className="list-group">
                                            {Object.entries(conversionResults).map(([karatKey, weight]) => (
                                                <li key={karatKey} className="list-group-item">
                                                    {parseFloat(weight).toFixed(2)} grams of {karatKey.replace("karat_", "")} karat gold
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.islamicCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h2 style={{ fontSize: '20px' }}>Description of Gold Karat Conversion Calculator</h2>
                            </div>
                            <div className="info-section-body">
                                <u><b>
                                    <h3 style={{ fontSize: '18px' }}>Gold Karat Conversion:</h3>
                                </b></u>
                                This <strong>Gold Karat Conversion Calculator</strong> helps you convert gold weight from one karat to another, such as from <strong>24K to 22K</strong> or any other karat value. Simply input the weight and original karat, and the calculator will provide the equivalent weight in your desired karat. This tool is especially useful for <strong>gold purity calculations</strong> and <strong>gold karat conversion</strong>.
                                <br />
                                The calculator ensures that all values are accurate and that the original karat does not exceed pure gold's karat value. It provides results for various karats including <strong>24K</strong>, <strong>22K</strong>, <strong>21K</strong>, <strong>18K</strong>, <strong>14K</strong>, and <strong>10K</strong>.
                                <br/>                                By using this calculator, you can easily manage <strong>gold weight conversions</strong> without needing extensive knowledge in gold karat values.
                                <br />
                                <hr />
                                <h3 style={{ fontSize: '18px' }}>Gold Conversion Formula:</h3>
                                <p>
                                    To convert the weight of gold from one karat to another, use the following formula:
                                </p>
                                <p>
                                    <b>Weight in new karat = (Pure Gold Weight) ÷ (New karat / 24)</b>
                                </p>
                                <p>
                                    Where:
                                    <ul>
                                        <li><b>Pure Gold Weight</b> is calculated as: Original Weight × (Original Karat / 24)</li>
                                        <li><b>New karat</b> is the karat value you want to convert to.</li>
                                    </ul>
                                </p>
                                <div className="alert alert-info mt-3">
                                    <b>Example:</b>
                                    <br />
                                    If you have 100 grams of 22 karat gold:
                                    <ul>
                                        <li>Pure gold content = 100 × (22/24) = 91.67 grams</li>
                                        <li>Conversion to 24K = 91.67 ÷ (24/24) = 91.67 grams (less than original weight)</li>
                                        <li>Conversion to 18K = 91.67 ÷ (18/24) = 122.22 grams (more than original weight)</li>
                                    </ul>
                                    <b>Important rule:</b> When converting to higher karat (purer gold), the weight decreases. When converting to lower karat (less pure), the weight increases.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
}
export default GoldKaratCalculator;